import type { NewsArticle } from '@/types/content';

export const news: NewsArticle[] = [
  {
    id: 'news-001',
    title: '2025年度华语电影盘点：现实题材成最大赢家',
    excerpt:
      '过去一年华语电影市场稳中有进，现实主义题材作品口碑与票房双丰收，成为年度最亮眼的现象。',
    content: [
      '过去一年，华语电影市场整体呈现稳中有进的态势。据不完全统计，全年国产影片总票房同比小幅增长，其中现实主义题材作品在口碑与票房两个维度上都表现抢眼，成为年度最受关注的现象。',
      '从年初的《长夜将尽》到暑期档的《铁血荣光》，越来越多创作者选择将镜头对准普通人的生活。这些作品不再依赖夸张的戏剧冲突，而是通过细腻的人物刻画与扎实的剧本，赢得观众的真心认可。多位影评人指出，观众审美正在成熟，真诚的故事比华丽的噱头更有生命力。',
      '与此同时，类型片的探索也在持续深入。悬疑、科幻、动画等多个类型均出现了具有突破意义的作品。业内普遍认为，类型多元化与内容精品化，将成为未来几年华语电影发展的两条主线。',
    ],
    date: '2025-09-28',
    category: '行业观察',
    author: '编辑部',
    views: 18420,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%20of%20a%20grand%20modern%20movie%20theater%20lobby%20with%20warm%20amber%20lighting%20and%20red%20carpets%2C%20wide%20atmospheric%20scene%2C%20moody%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20photorealistic%2C%20high%20detail%2C%20cinematic%20color%20grading%2C%20elegant%20composition%2C%20no%20text&width=1200&height=675&seq=news-001-cover&orientation=landscape',
    tags: ['华语电影', '年度盘点', '行业'],
  },
  {
    id: 'news-002',
    title: '科幻新作《星际回声》全球首映，视效引发热议',
    excerpt:
      '备受期待的科幻巨制在多地同步举行首映，宏大的宇宙场景与细腻情感收获大量好评。',
    content: [
      '上周，科幻电影《星际回声》在多地同步举行全球首映礼。影片凭借震撼的宇宙场景与扎实的叙事，在首映结束后迅速点燃社交平台讨论，多个相关话题登上热搜。',
      '导演 Elias Vance 在映后交流中表示，影片虽然披着硬核科幻的外衣，但讲述的是一个非常"人类"的故事——关于孤独、沟通与理解。技术团队透露，片中大量太空镜头由全新渲染流程完成，在保持真实质感的同时兼顾了成本与效率。',
      '截至目前，影片在多个评分平台的分数均保持在高位。不少观众评价，这是"近年来最有温度的科幻片"。业内预计，影片有望成为本年度最具影响力的引进作品之一。',
    ],
    date: '2025-09-20',
    category: '新片速递',
    author: '林澈',
    views: 15260,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%20of%20a%20premiere%20red%20carpet%20event%20with%20spotlights%20and%20a%20large%20glowing%20screen%2C%20wide%20atmospheric%20scene%2C%20moody%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20photorealistic%2C%20high%20detail%2C%20cinematic%20color%20grading%2C%20elegant%20composition%2C%20no%20text&width=1200&height=675&seq=news-002-cover&orientation=landscape',
    tags: ['科幻', '首映', '视效'],
  },
  {
    id: 'news-003',
    title: '专访《长夜将尽》导演：悬疑外壳下的人性追问',
    excerpt:
      '陈砚舟谈创作初衷：他更想拍的是人在真相面前的挣扎，而不是案件本身。',
    content: [
      '凭借《长夜将尽》收获广泛好评后，导演陈砚舟很少出现在公众视野。这一次，他接受了本刊的独家专访，聊了聊这部作品背后的思考。',
      '“这不是一部关于谁是凶手的电影，”陈砚舟说，“我真正想拍的是，当真相摆在面前，人会用什么样的方式去面对。”在他看来，悬疑只是一个容器，装进去的应该是更普世的情感。',
      '谈到备受称赞的长镜头调度，他坦言拍摄过程并不轻松。剧组在北方一座废弃工厂里待了整整两个月，很多场景都是在寒冷与泥泞中反复打磨出来的。"我希望能让观众相信，那个地方真的存在。"',
      '当被问及是否会拍摄续集时，他笑着摇头："故事已经讲完了，我更想去做下一个新的东西。"',
    ],
    date: '2025-09-12',
    category: '人物专访',
    author: '苏晓',
    views: 9870,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%20of%20a%20film%20director%20silhouette%20on%20an%20empty%20sound%20stage%20with%20warm%20amber%20light%2C%20wide%20atmospheric%20scene%2C%20moody%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20photorealistic%2C%20high%20detail%2C%20cinematic%20color%20grading%2C%20elegant%20composition%2C%20no%20text&width=1200&height=675&seq=news-003-cover&orientation=landscape',
    tags: ['专访', '导演', '幕后'],
  },
  {
    id: 'news-004',
    title: '暑期档前瞻：五部高期待剧集即将上线',
    excerpt:
      '从古装权谋到都市情感，本季待播剧集类型丰富，多部作品未播先热。',
    content: [
      '随着新一季的到来，多部备受关注的剧集陆续定档。从目前公布的片单来看，今年待播作品在题材分布上相当均衡，古装、都市、悬疑、家庭各有代表作。',
      '其中，古装权谋剧《王朝风云》凭借精良的制作班底与考究的预告质感，成为讨论度最高的作品之一。都市情感剧《都市之光》则主打细腻真实的烟火气，被不少观众列入追剧清单。',
      '此外，几部悬疑与奇幻题材的剧集也各具特色。平台方表示，今年会更加注重内容质量而非数量，希望用更扎实的作品回馈观众。究竟谁能成为下一部话题之作，值得期待。',
    ],
    date: '2025-09-05',
    category: '新剧前瞻',
    author: '顾南',
    views: 11230,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%20of%20a%20stack%20of%20glowing%20screens%20showing%20dramatic%20scenes%20in%20a%20dark%20warm%20room%2C%20wide%20atmospheric%20scene%2C%20moody%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20photorealistic%2C%20high%20detail%2C%20cinematic%20color%20grading%2C%20elegant%20composition%2C%20no%20text&width=1200&height=675&seq=news-004-cover&orientation=landscape',
    tags: ['剧集', '前瞻', '待播'],
  },
  {
    id: 'news-005',
    title: '影评｜《樱花之下》：在克制中讲述时代情感',
    excerpt:
      '这部作品没有大开大合的情节，却用最细腻的笔触打动了无数观众。',
    content: [
      '好的作品往往懂得克制。《樱花之下》就是这样一部作品，它几乎拒绝了所有煽情的捷径，却让许多人在最后一集红了眼眶。',
      '剧集采用双时间线叙事，在过去与现在之间自如切换。导演没有急于交代因果关系，而是让观众随着信件一起慢慢拼凑出完整的往事。这种"留白"的处理，反而给了情感更大的生长空间。',
      '演员的表演同样值得称道。主角们收着演的每一个微表情，都比大段的台词更有力量。可以说，《樱花之下》重新定义了言情剧的质感标准——原来深情，可以如此安静。',
    ],
    date: '2025-08-28',
    category: '影评',
    author: '周知微',
    views: 8460,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%20of%20sakura%20petals%20drifting%20over%20a%20quiet%20warm%20street%20at%20golden%20hour%2C%20wide%20atmospheric%20scene%2C%20moody%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20photorealistic%2C%20high%20detail%2C%20cinematic%20color%20grading%2C%20elegant%20composition%2C%20no%20text&width=1200&height=675&seq=news-005-cover&orientation=landscape',
    tags: ['影评', '爱情', '深度'],
  },
  {
    id: 'news-006',
    title: '国漫崛起：《龙影传说》票房破十亿的背后',
    excerpt:
      '一部原创动画电影如何突破重围？从制作到叙事，它的成功并非偶然。',
    content: [
      '国产动画电影《龙影传说》上映后一路走高，票房正式突破十亿大关，成为本年度最成功的原创动画作品之一。票房数字的背后，是一支团队数年的坚持。',
      '据主创透露，影片从概念设计到最终成片历时近五年，仅主角与龙的互动镜头就反复打磨了上百个版本。团队希望塑造的不仅是一头威武的东方龙，更是一个有性格、有温度的伙伴。',
      '在叙事上，影片选择了"少年与伙伴"的经典母题，却赋予了其独特的东方情感内核。业内评论认为，这种扎根本土文化的表达，正是国漫持续突破的关键。',
    ],
    date: '2025-08-15',
    category: '行业观察',
    author: '编辑部',
    views: 12980,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%20of%20a%20glowing%20eastern%20dragon%20artwork%20on%20a%20warm%20red%20studio%20wall%20with%20amber%20lighting%2C%20wide%20atmospheric%20scene%2C%20moody%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20photorealistic%2C%20high%20detail%2C%20cinematic%20color%20grading%2C%20elegant%20composition%2C%20no%20text&width=1200&height=675&seq=news-006-cover&orientation=landscape',
    tags: ['国漫', '动画', '票房'],
  },
  {
    id: 'news-007',
    title: '技术解析：虚拟制片如何改变电影工业',
    excerpt:
      '从绿幕到实时渲染，虚拟制片正在重塑电影拍摄的工作流程与创作边界。',
    content: [
      '在过去，演员常常需要在空荡荡的绿幕前想象场景。而如今，虚拟制片技术让导演能够在拍摄现场就看到接近成片的画面，大幅提升了效率与表演的真实感。',
      '虚拟制片的核心，是将实时渲染引擎与巨型 LED 屏结合。背景不再是后期合成，而是当场呈现。演员可以直接对真实存在的画面做出反应，灯光与反射也更加自然。',
      '当然，新技术也带来了新的挑战——如何在有限的空间里呈现无限的世界。多部采用该技术的作品证明，只要创作理念跟得上，技术就能成为想象力的翅膀。',
    ],
    date: '2025-08-02',
    category: '技术前沿',
    author: '钟远',
    views: 7320,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%20of%20a%20virtual%20production%20led%20volume%20stage%20with%20warm%20amber%20glow%20and%20cameras%2C%20wide%20atmospheric%20scene%2C%20moody%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20photorealistic%2C%20high%20detail%2C%20cinematic%20color%20grading%2C%20elegant%20composition%2C%20no%20text&width=1200&height=675&seq=news-007-cover&orientation=landscape',
    tags: ['技术', '虚拟制片', '幕后'],
  },
  {
    id: 'news-008',
    title: '佳片推荐：五部被低估的悬疑电影',
    excerpt:
      '它们或许没有大明星和大场面，却用扎实的剧本和巧妙的构思征服了观众。',
    content: [
      '悬疑片是最考验编剧功力的类型之一——一个逻辑漏洞就可能毁掉整部作品。今天推荐的五部电影，都称得上是"低开高走"的惊喜之作。',
      '这些作品大多成本不高，却凭借对细节的极致追求和对人性的深刻洞察脱颖而出。它们的共同点是：不到最后一刻，你很难猜到真相。',
      '如果你已经看腻了套路满满的商业大片，不妨从这份片单开始，重新找回被剧情牵着走的那种惊喜。相信其中至少有一部，会让你在片尾字幕亮起时久久不能平静。',
    ],
    date: '2025-07-18',
    category: '佳片推荐',
    author: '沈墨',
    views: 10140,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%20of%20a%20lone%20armchair%20and%20a%20flickering%20projector%20beam%20in%20a%20dark%20warm%20room%2C%20wide%20atmospheric%20scene%2C%20moody%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20photorealistic%2C%20high%20detail%2C%20cinematic%20color%20grading%2C%20elegant%20composition%2C%20no%20text&width=1200&height=675&seq=news-008-cover&orientation=landscape',
    tags: ['推荐', '悬疑', '片单'],
  },
];